export const useSkillsStore = defineStore('skills', {
  state: () => ({
    skills: [],
  }),
  actions: {
    setSkills(skills) {
      this.skills = skills;
    },
  },
});
